import axiosInstance from '../../../../../../utils/axiosConfig'
import { mobileBackendUrl } from '../../../../../../env'
import { SipRecommendationActionType } from '../../api/common.types'
import type { SipIdealPlanRecommendationApiResponse } from './idealRecommendation.types'
import type { SipPlanRecommendationApiResponse } from './sipPlanRecommendation.types'

const SIP_PLAN_RECOMMENDATION_URL = `${mobileBackendUrl}/v2/portfolio/allocation-plan/sip`
const SIP_IDEAL_PLAN_RECOMMENDATION_URL = `${mobileBackendUrl}/v2/portfolio/allocation-plan/sip/ideal`

export async function fetchSipPlanRecommendation(
  isin: string,
  recommendationAction: SipRecommendationActionType
): Promise<SipPlanRecommendationApiResponse> {
  const recommendationUrl = `${SIP_PLAN_RECOMMENDATION_URL}/${encodeURIComponent(isin)}`
  const response = await axiosInstance.get<SipPlanRecommendationApiResponse>(recommendationUrl, {
    params: {
      recommendationAction
    }
  })
  if (!response?.data) {
    throw new Error('Failed to fetch SIP plan recommendation')
  }
  return response.data
}

export async function fetchSipIdealPlanRecommendation(
  isin: string
): Promise<SipIdealPlanRecommendationApiResponse> {
  const recommendationUrl = `${SIP_IDEAL_PLAN_RECOMMENDATION_URL}/${encodeURIComponent(isin)}`
  const response = await axiosInstance.get<SipIdealPlanRecommendationApiResponse>(recommendationUrl)
  if (!response?.data) {
    throw new Error('Failed to fetch SIP ideal plan recommendation')
  }
  return response.data
}
